import { Maybe } from '@repo/utils'
import dayjs from 'dayjs'
import fr from 'dayjs/locale/fr'

import { DateFormatter } from './DateFormatter'
import { HouseOptionsSeasonPrice } from '../lib/graphql'

dayjs.locale(fr)

export function handleDate(date: Date) {
  const days = dayjs().diff(date, 'days')
  const hours = dayjs().diff(date, 'hours')
  const min = dayjs().diff(date, 'minutes')

  if (dayjs().startOf('day').diff(dayjs(date).startOf('day'), 'days') === 1) {
    return 'Hier'
  }
  if (days === 0) {
    if (hours === 0) {
      return min ? `${min}min` : 'Maintenant'
    } else {
      return `${hours}h`
    }
  } else if (days < 7) {
    return dayjs(date).format('dddd')
  } else {
    return dayjs(date).format('DD/MM')
  }
}

export function getSeasonFromMonth(
  month: number,
): keyof Omit<HouseOptionsSeasonPrice, '__typename'> {
  if (month > 4 && month < 9) {
    return 'highPrice'
  } else if (month === 3 || month === 4 || month === 9) {
    return 'mediumPrice'
  } else {
    return 'lowPrice'
  }
}

export function isWeekendDay(day: number): boolean {
  return day === 5 || day === 6
}

export const getFormattedDate = ({
  formatter,
  endDate,
  startDate,
}: {
  startDate?: Maybe<Date>
  endDate?: Maybe<Date>
  formatter: DateFormatter
}) => {
  if (!startDate && !endDate) {
    return ''
  }

  return formatter.formatDateRange({
    startDate: startDate ?? undefined,
    endDate: endDate ?? undefined,
    formatString: 'DD/MM/YY',
    useUTC: true,
  })
}
